module.exports = __webpack_public_path__ + "img/SKIPHOVER.c275768d.png";